import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/69c6f33dc3f848001344e705/dilo_card/src/app/sign-up-login-screen/components/AuthForm.tsx");
